import { request } from '@/shared/api/request'
export const getRequestAdjustmentDetail = (id) => {
	return request({ url: `contract/labor/jur/getRequestsAdjustmentDataDetail?reqAdjId=${id}`, method: 'GET' })
}
